import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { User } from '../../../_models/user';
import { NavigationService } from '../../../_services/navigation.service';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import Menu from 'src/app/modules/_models/menu.model';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../_services/auth.service';
import { CookieService } from '../../../_services/cookie.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  width: number = window.innerWidth;

  public existeNotificacaoNova: boolean = false;

  membro: any = undefined;
  public membroSubscription: Subscription;

  currentUser: User = null;
  logado: boolean = true;
  paginaAtual: string = '';
  urlAtual: string = '';

  exibirHeader: boolean = true;
  exibirDropdownUsuario: boolean = false;
  exibirPopupLogout: boolean = false;
  exibirSubheader: boolean = true;
  subheaderTitulo: string = '';
  exibirPontuacaoSaldo: boolean = false;

  menus: Menu[] = [];

  menuMobileAberto: boolean = false;

  exibirNotificacao: boolean = false;

  // Esta na tela de validar dados
  estaEmValidarDados: boolean = false;

  // Identifica se está no app
  appOnly: boolean = false;
  voltarButton: boolean = false;

  // Scroll function
  private myScrollFunc: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private fidelidadeService: FidelidadeService,
    private cookieServeice: CookieService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.urlAtual = event.url;
      }
    });

    this.route.queryParams.subscribe((params) => {
      if (params.app) {
        if (params.app == 'true') {
          this.appOnly = true;
          this.fidelidadeService.LocalStorage.salvarObjetoLocal(
            'sessao_app',
            true
          );
          this.carregarMembroLogado();
        }
      }
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.tratarExibicao(event.urlAfterRedirects.trim());

        this.membroSubscription =
          this.authService.LocalStorage.currentUserMembro.subscribe(
            (membro) => {
              this.membro = membro;
            }
          );

        if (this.logado && this.membro !== undefined) {
          this.authService.LocalStorage.currentUserToken.subscribe((user) => {
            this.currentUser = user;
          });

          this.carregarMenusLogado();
          // this.carregarMembroLogado();
          //this.obterNotificacoes();
        }

        if (!this.logado && !this.membro) {
          this.carregarMenusDeslogado();
        }
      }
    });

    this.onScroll();

    this.authService.LocalStorage.currentUserMembro.subscribe((membro) => {
      if (membro != '' && membro != undefined && membro != null) {
        this.carregarMembroLogado();
        this.tratarExibicao(this.router.url);
      } else this.membro = undefined;
    });
  }

  ngOnDestroy(): void {
    this.membroSubscription.unsubscribe();
    window.removeEventListener('scroll', this.myScrollFunc);
  }

  sendMemberCookie() {
    let telefoneTratado;
    if (this.membro.telefone != null) {
      let tel = this.membro.telefone;
      telefoneTratado = tel.replace('55', '', 1);
    }
    const cookie = {
      nome: this.membro.nome,
      cpf: this.membro.cpf,
      email: this.membro.email,
      telefone: telefoneTratado,
    };

    this.cookieServeice.setSecureCookie('_fidelity', cookie);
  }

  private tratarExibicao(url: string) {
    const href = url.trim();
    const paginaAtual: Menu = this.navigationService.obterPaginaPorLink(href);
    this.paginaAtual = href;

    if (
      this.paginaAtual.includes('valida-dados') ||
      this.paginaAtual.includes('validar-dados')
    ) {
      this.estaEmValidarDados = true;
    } else {
      this.estaEmValidarDados = false;
    }

    this.exibirSubheader = paginaAtual.subheader.exibir;
    this.subheaderTitulo = paginaAtual.subheader.titulo;
    this.exibirHeader = paginaAtual.header.exibir;
    this.exibirPontuacaoSaldo = paginaAtual.subheader.exibirSaldoPontuacao;
    this.logado = paginaAtual.logado;
  }

  private carregarMembroLogado(): void {
    this.membro = this.authService.LocalStorage.obterMembro();
    let estaApp =
      this.fidelidadeService.LocalStorage.obterObtejoLocal('sessao_app');

    if (estaApp != null && estaApp != '') {
      this.voltarButton = true;
    } else {
      this.voltarButton = false;
    }
    this.obterNotificacoes();
  }

  codeIdLovers(): string {
    const lengthId = this.membro.id;
    const idFormat = lengthId.toString().padStart(12, '0');
    return idFormat;
  }

  private carregarMenusLogado(): void {
    this.menus = this.navigationService.obterMenuLogado();
  }

  private carregarMenusDeslogado(): void {
    this.menus = this.navigationService.obterMenuDeslogado();
  }

  public navegarPara(menuItem: Menu): void {
    this.menuMobileAberto = false;
    this.navigationService.irPara(menuItem);
  }

  public exibirUsuarioDropdown(): void {
    this.exibirDropdownUsuario = !this.exibirDropdownUsuario;
    const infoUser = document.getElementById('info__user');
    if (this.exibirDropdownUsuario) {
      infoUser.classList.add('active__info__user');
    } else {
      infoUser.classList.remove('active__info__user');
    }
  }

  public irParaMinhasExperiencias() {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('/minhas-experiencias');
  }

  public irParaMissoes() {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('/missoes');
  }

  public irParaMeusDados(): void {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('/meusdados');
  }

  public irParaBeneficios(): void {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('/beneficios');
  }

  public irParaPalito(): void {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('/palito-premiado');
  }

  public irParaExtrato(): void {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('/extrato');
  }

  public irParaCausa(): void {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('/lovers-pela-causa');
  }

  public irParaAjuda() {
    this.menuMobileAberto = false;
    this.sendMemberCookie();

    window.location.href = `${environment.urlSac}cacaulovers`;
  }

  public exibirModalLogout(show: boolean) {
    this.exibirPopupLogout = show;
  }

  public irParaNotificacoes(): void {
    this.menuMobileAberto = false;
    this.router.navigate(['/notificacoes']);
  }

  public irParaAprovacoes(): void {
    this.menuMobileAberto = false;
    this.router.navigate(['/solicitacoes']);
  }

  public irParaIndicacoes(): void {
    this.menuMobileAberto = false;
    this.router.navigate(['/indicacoes']);
  }

  public irParaMomentosEspeciais(): void {
    this.menuMobileAberto = false;
    this.router.navigate(['/momentos-especiais']);
  }

  public desconectar(): void {
    this.exibirModalLogout(false);
    this.menuMobileAberto = false;
    this.authService.LocalStorage.desconectar();
    this.navigationService.irParaPorLink('/home');
    this.logado = false;
    this.membro = undefined;
    this.currentUser = null;
    this.paginaAtual = '';
    this.exibirDropdownUsuario = false;
    this.exibirPopupLogout = false;
    this.exibirSubheader = true;
    this.subheaderTitulo = '';
    this.menus = [];
    this.exibirPontuacaoSaldo = false;
    this.menuMobileAberto = false;
  }

  public irParaEcommerce(): void {
    this.menuMobileAberto = false;
    this.navigationService.irParaPorLink('https://www.cacaushow.com.br/', true);
  }

  public irParaHome(): void {
    this.menuMobileAberto = false;
    this.router.navigate(['/home']);
  }

  public irParaoPrograma(): void {
    this.menuMobileAberto = false;
    this.router.navigate(['/programa']);
  }

  public irParaLogin(): void {
    const link = '/lovers-pela-causa';
    this.router.navigate(['/home'], {
      queryParams: {
        redirectLink: btoa(link),
        login: btoa('1'),
      },
    });
  }
  public irParaCadastro(): void {
    const link = '/lovers-pela-causa';
    this.router.navigate(['/home'], {
      queryParams: {
        redirectLink: btoa(link),
        cadastro: btoa('1'),
      },
    });
  }

  public obterNotificacoes() {
    this.fidelidadeService
      .ObterGrupoNotificacaoPorIdMembroOuNivel(false, this.membro.id, null)
      .subscribe({
        next: (res: any) =>
          this.processarSucessoObterGrupoNotificacaoPorIdMembroOuNivel(res),
        error: (err: any) =>
          this.processarFalhaObterGrupoNotificacaoPorIdMembroOuNivel(err),
      });
  }

  public processarSucessoObterGrupoNotificacaoPorIdMembroOuNivel(res: any) {
    const sino = <HTMLInputElement>document.getElementById('sino');

    if (res != null && res.length > 0) {
      // var existeNotificacaoNova = false;

      for (let index = 0; index < res.length; index++) {
        const element = res[index].notificacao;

        if (
          element.notificacaoStatus != null &&
          element.notificacaoStatus.length > 0
        )
          this.existeNotificacaoNova = !element.notificacaoStatus[0].lida;
        else this.existeNotificacaoNova = true;

        if (this.existeNotificacaoNova) break;
      }

      if (this.existeNotificacaoNova) {
        sino.setAttribute(
          'src',
          'assets/images/icons/sino_com_notificacao.png'
        );
        sino.style.width = '30px';
        sino.style.height = '32px';
      } else {
        sino?.setAttribute('src', 'assets/images/icons/sino.png');
      }

      this.exibirNotificacao = this.existeNotificacaoNova;
    }
  }

  public processarFalhaObterGrupoNotificacaoPorIdMembroOuNivel(res: any) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = window.innerWidth;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    const myIdMobile = document.getElementById('card--top--mobile');
    const myIdDesktop = document.getElementById('card--top--desktop');
    if (
      this.router.url === '/index' &&
      myIdDesktop != null &&
      myIdMobile != null
    ) {
      let y = window.scrollY;
      if (y >= 170) {
        myIdMobile.className = 'show';
        myIdDesktop.className = 'show';
      } else {
        myIdMobile.className = 'hide';
        myIdDesktop.className = 'hide';
      }
    }
  }

  voltarPagAnterior() {
    if (this.menuMobileAberto) this.menuMobileAberto = false;
    history.back();
  }

  public irPara(link: string, linkExterno: boolean) {
    this.navigationService.irParaPorLink(link, linkExterno);
  }

  mostrarPopupTermos() {
    this.fidelidadeService.abrirTermoApp();
  }

  mostrarPopupRegulamento() {
    this.fidelidadeService.abrirRegulamento();
  }
}
